import { useEffect, useState } from "react";

export function useMatchBreakpoint(breakpoint = 800) {
  const [isMobile, setIsMobile] = useState(undefined);

  useEffect(() => {
    if (isNaN(breakpoint)) {
      console.error('Breakpoint must be a number');
      return;
    }
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    mql.addEventListener('change', onChange);

    setIsMobile(window.innerWidth < breakpoint);

    return () => {
      mql.removeEventListener('change', onChange);
    };
  }, [breakpoint]);

  return !!isMobile;
}